import { render, staticRenderFns } from "./shop-type-list.vue?vue&type=template&id=18f8b16a&"
import script from "./shop-type-list.vue?vue&type=script&lang=js&"
export * from "./shop-type-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports